
  
import { useEffect, useState } from "react";
import { GoThreeBars } from "react-icons/go";
import "./Navbar.css";
// import Prachi_Tiwari_Resume from "../Prachi-Tiwari-Resume.pdf";
// import { saveAs } from "file-saver";
import { HashLink as Link } from "react-router-hash-link";
// import white from "../logo/white.png"
// import logominepor from "../logo/logominepor.png";

const Navbar = () => {
  const handleClick = () => {
   window.open(
     "https://drive.google.com/file/d/1OPPhvBlcU1gxAyDePRObJPkoi14-ct3a/view?usp=sharing",
     "_blank"
   );
  };
  const [name, setName] = useState(false);
  // const [hover, setHover] = useState(false);
  const handleScroll = () => {
    const scrollPosition = window.scrollY; // => scroll position
    let com = document.getElementById("navComp");
    if (scrollPosition > 20) {
      setName(true);
      com.classList.add("mystyle");
    } else {
      setName(false);
      com.classList.remove("mystyle");
    }
  };
  useEffect(() => {
    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);
  // console.log(hover)
  function openNav() {
    document.getElementById("myNav").style.height = "100%";
  }

  function closeNav() {
    document.getElementById("myNav").style.height = "0%";
  }

  return (
    <div
      style={{
        padding: name ? "15px 40px" : "",
        backgroundColor: name ? "black" : "transparent",
        color: name ? "gold" : "gold",
      }}
      id="nav-menu"
    >
      <a href="/">
        {" "}
        <p
          style={{
            color: name ? "teal" : "green",
          }}
          id="navName"
        >
          PraChi T..
        </p>
      </a>

      <p id="navComp" style={{ color: name ? "gold" : "gold" }}>
        <Link className="nav-link home" to="#home" smooth>
          Home
        </Link>
        {/* <Link to="#about" smooth >About</Link> */}
        <Link className="nav-link about" to="#about" smooth>
          About
        </Link>
        <Link className="nav-link skills" to="#skills" smooth>
          Skills
        </Link>
        <Link className="nav-link projects" to="#projects" smooth>
          Projects
        </Link>
        <Link className="nav-link contact" to="#contact" smooth>
          Contact
        </Link>
        <button
          onClick={handleClick}
          id="resume-button-1"
          className="nav-link resume"
        >
          <a
            id="resume-link-1"
            href="Prachi-Tiwari-Resume.pdf"
            target="_blank"
            download="Prachi-Tiwari-Resume.pdf"
          >
            Resume
          </a>
        </button>
      </p>
      <p
        id="mobile"
        onClick={openNav}
        style={{
          fontSize: "30px",
          color: "white",
          cursor: "pointer",
          float: "right",
          textAlign: "center",
        }}
      >
        <GoThreeBars />
      </p>

      <div id="myNav" className="overlay" style={{cursor:"pointer"}}>
        <a className="closebtn" onClick={closeNav}>
          &times;
        </a>
        <div className="overlay-content">
          <Link to="#home" smooth onClick={closeNav}>
            HOME
          </Link>
          <Link to="#about" smooth onClick={closeNav}>
            ABOUT
          </Link>
          <Link to="#skills" smooth onClick={closeNav}>
            SKILLS
          </Link>
          <Link to="#projects" smooth onClick={closeNav}>
            PROJECTS
          </Link>
          <Link to="#contact" smooth onClick={closeNav}>
            CONTACT
          </Link>
          <button
            onClick={handleClick}
            id="resume-button-11"
            className="nav-link resume"
          >
            <a
              id="resume-link-1"
              href="Prachi-Tiwari-Resume.pdf"
              target="_blank"
              download="Prachi-Tiwari-Resume.pdf"
            >
              Resume
            </a>
          </button>
        </div>
      </div>
    </div>
  );
};

export { Navbar };
